export const rows = [
  {
    id: 1,
    sssJobNo: "V2763957",
    custOrder: "AGE091",
    customer: "MS Auto",
    orderDate: "03/19/2025 09:16",
    orderLine: 2,
    pickUpQty: 4,
    bay: "M6-Bay 6",
    cutoff: "04:00 PM/10:30 AM",
    picker: {
      id: 1,
      name: "Zayden Cole",
      avatar: "https://i.pravatar.cc/150?img=1",
    },
    status: "On Hold",
    isPriorityOrder: true,
  },
  {
    id: 2,
    sssJobNo: "V2763958",
    custOrder: "AGE093",
    customer: "MS Auto",
    orderDate: "03/19/2025 09:48",
    orderLine: 1,
    pickUpQty: 1,
    bay: "M1-Bay 1",
    cutoff: "03:00 PM/11:30 AM",
    picker: {
      id: 2,
      name: "Olivia Hayes",
      avatar: "https://i.pravatar.cc/150?img=2",
    },
    status: "In Progress",
    isPriorityOrder: true,
  },
  {
    id: 3,
    sssJobNo: "V2763959",
    custOrder: "MGO94",
    customer: "Evander Rhys",
    orderDate: "03/19/2025 09:52",
    orderLine: 3,
    pickUpQty: 3,
    bay: "M3-Bay 6",
    cutoff: "04:00 PM/10:30 AM",
    picker: {
      id: 3,
      name: "Mason Clarke",
      avatar: "https://i.pravatar.cc/150?img=3",
    },
    status: "On Hold",
    isPriorityOrder: true,
  },
  {
    id: 4,
    sssJobNo: "V2763940",
    custOrder: "BYD032",
    customer: "Captain Clark",
    orderDate: "03/19/2025 09:55",
    orderLine: 2,
    pickUpQty: 3,
    bay: "M1-Bay 6",
    cutoff: "03:00 PM/11:30 AM",
    picker: {
      id: 4,
      name: "Emma Johnson",
      avatar: "https://i.pravatar.cc/150?img=4",
    },
    status: "Completed",
    isPriorityOrder: false,
  },
  {
    id: 5,
    sssJobNo: "V2763941",
    custOrder: "NS011",
    customer: "Silvester Stan...",
    orderDate: "04/19/2025 09:56",
    orderLine: 5,
    pickUpQty: 7,
    bay: "M4-Bay 2",
    cutoff: "04:00 PM/10:30 AM",
    picker: {
      id: 5,
      name: "Liam Smith",
      avatar: "https://i.pravatar.cc/150?img=5",
    },
    status: "In Progress",
    isPriorityOrder: false,
  },
  {
    id: 6,
    sssJobNo: "V2763942",
    custOrder: "TES021",
    customer: "Will Smith",
    orderDate: "03/19/2025 09:58",
    orderLine: 2,
    pickUpQty: 3,
    bay: "M6-Bay 6",
    cutoff: "03:00 PM/11:30 AM",
    picker: {
      id: 1,
      name: "Zayden Cole",
      avatar: "https://i.pravatar.cc/150?img=1",
    },
    status: "In Queue",
    isPriorityOrder: true,
  },
  {
    id: 7,
    sssJobNo: "V2763943",
    custOrder: "ODI033",
    customer: "Dante Phoenix",
    orderDate: "04/19/2025 11:21",
    orderLine: 2,
    pickUpQty: 2,
    bay: "M5-Bay 1",
    cutoff: "04:00 PM/10:30 AM",
    picker: "-",
    status: "In Queue",
    isPriorityOrder: false,
  },
  {
    id: 8,
    sssJobNo: "V2763944",
    custOrder: "SU055",
    customer: "Dorrin Miessi",
    orderDate: "03/19/2025 09:26",
    orderLine: 3,
    pickUpQty: 4,
    bay: "M4-Bay 3",
    cutoff: "03:00 PM/11:30 AM",
    picker: {
      id: 2,
      name: "Olivia Hayes",
      avatar: "https://i.pravatar.cc/150?img=2",
    },
    status: "In Queue",
    isPriorityOrder: false,
  },
  {
    id: 9,
    sssJobNo: "V2763945",
    custOrder: "AGE074",
    customer: "MS Auto",
    orderDate: "04/19/2025 06:29",
    orderLine: 1,
    pickUpQty: 1,
    bay: "M6-Bay 6",
    cutoff: "04:00 PM/10:30 AM",
    picker: "-",
    status: "In Queue",
    isPriorityOrder: false,
  },
];
